import { ShoppingBag } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
    Card,
    CardContent,
} from '@/components/ui/card';

interface CartEmptyStateProps {
    onBrowse: () => void;
}

export function CartEmptyState({ onBrowse }: CartEmptyStateProps) {
    return (
        <div>
            <Card className="border-0 shadow-sm">
                <CardContent className="flex flex-col items-center justify-center py-20 text-center">
                    <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10">
                        <ShoppingBag className="h-7 w-7 text-primary" />
                    </div>
                    <h2 className="text-xl font-bold">Your cart is empty</h2>
                    <p className="mt-2 max-w-md text-sm text-muted-foreground">
                        Add products from a related party to start building your order.
                    </p>
                    <Button className="mt-6" onClick={onBrowse}>
                        Browse Related Parties
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
}
